var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "secondary-toolbar d-flex align-center justify-end" },
    [
      _c(
        "v-btn",
        {
          staticClass: "font-hemi-head mr-1",
          attrs: {
            rounded: "",
            small: "",
            depressed: "",
            outlined: "",
            color: "secondary",
          },
          on: { click: _vm.promptImpostazioni },
        },
        [
          _c("v-icon", { attrs: { "x-small": "", left: !_vm.is_mobile } }, [
            _vm._v("settings"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "quick-mode-name d-none d-sm-flex" }, [
            _vm._v("\n      " + _vm._s(_vm.asta_mode_name) + "\n    "),
          ]),
          _vm._v(" "),
          _c("v-icon", { attrs: { small: "", right: !_vm.is_mobile } }, [
            _vm._v("expand_more"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: { "offset-y": "", left: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-badge",
                    {
                      staticClass: "secondary-toolbar-new-badge mr-1",
                      attrs: {
                        color: "error",
                        content: "NEW",
                        "offset-x": "20",
                        "offset-y": "8",
                        overlap: "",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "secondary-toolbar-btn con-ombra",
                              attrs: {
                                fab: "",
                                "x-small": "",
                                depressed: "",
                                title: "Scegli visuale",
                              },
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("view_module"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            {
              staticClass: "secondary-toolbar-layout-menu navy darken-1",
              attrs: { dense: "", dark: "" },
            },
            [
              _c(
                "v-subheader",
                { staticClass: "secondary-toolbar-layout-menu-title" },
                [_vm._v("\n        Scegli visuale\n      ")]
              ),
              _vm._v(" "),
              _vm._l(_vm.layoutOptions, function (layout) {
                return _c(
                  "v-list-item",
                  {
                    key: layout.value,
                    class: {
                      "secondary-toolbar-layout-menu-item--active":
                        _vm.isLayoutOptionActive(layout.value),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectLayout(layout.value)
                      },
                    },
                  },
                  [
                    _c(
                      "v-list-item-icon",
                      { staticClass: "mr-3" },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v(_vm._s(layout.icon)),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-item-content",
                      [
                        _c("v-list-item-title", [_vm._v(_vm._s(layout.text))]),
                        _vm._v(" "),
                        _c("v-list-item-subtitle", [
                          _vm._v(
                            "\n            " +
                              _vm._s(layout.subtitle) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isLayoutOptionActive(layout.value)
                      ? _c(
                          "v-list-item-icon",
                          { staticClass: "ml-3" },
                          [
                            _c(
                              "v-icon",
                              { attrs: { small: "", color: "accent" } },
                              [_vm._v("check")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "secondary-toolbar-btn mr-1 con-ombra",
          attrs: {
            fab: "",
            "x-small": "",
            depressed: "",
            title: _vm.useSound ? "Disattiva audio" : "Attiva audio",
          },
          on: { click: _vm.toggleUseSound },
        },
        [
          _c("v-icon", { attrs: { small: "" } }, [
            _vm._v(_vm._s(_vm.useSound ? "volume_up" : "volume_off")),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.Config.STANDALONE && !_vm.is_mobile
        ? _c(
            "v-btn",
            {
              staticClass: "secondary-toolbar-btn mr-1 con-ombra",
              attrs: { fab: "", "x-small": "", depressed: "" },
              on: { click: _vm.promptSaveRose },
            },
            [_c("v-icon", { attrs: { small: "" } }, [_vm._v("save")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.Config.STANDALONE && !_vm.is_mobile
        ? _c(
            "v-btn",
            {
              staticClass: "secondary-toolbar-btn mr-1 con-ombra",
              attrs: { fab: "", "x-small": "", depressed: "" },
              on: {
                click: function ($event) {
                  return _vm.checkAllineamentoRose(true)
                },
              },
            },
            [_c("v-icon", { attrs: { small: "" } }, [_vm._v("sync")])],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }